import { useCallback, useEffect, useState } from "react";

import EventEmitter from "events";

const eventEmitter = new EventEmitter();
eventEmitter.setMaxListeners(1);

const useFetchKeyForEvent = (eventName: string) => {
	const [fetchKey, setFetchKey] = useState(0);

	const refetch = useCallback(() => {
		setFetchKey(prev => prev + 1);
	}, []);

	useEffect(() => {
		eventEmitter.on(eventName, refetch);

		return () => {
			eventEmitter.off(eventName, refetch);
		};
	}, [eventName, refetch]);

	return fetchKey;
};

export { eventEmitter, useFetchKeyForEvent };
